import ScalarButton_vue_vue_type_script_setup_true_lang_default from "./ScalarButton.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarButton/ScalarButton.vue
var ScalarButton_default = ScalarButton_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarButton_default as default };

//# sourceMappingURL=ScalarButton.vue.js.map